import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Image from "react-bootstrap/Image";
import Card from "react-bootstrap/Card";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Formik } from "formik";
import * as yup from "yup";
import Select, { StylesConfig } from "react-select";
import { clearForgetpassSendmail, forgetpassSendmail } from "../../redux/handlers/auth/forgetpassSendmail.handler";
import { mapMstToOptions } from "utils/HelperFunction";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import ModalSuccessCustom from "layouts/ModalSuccessCustom";
import { useAppDispatch, useAppSelector } from "../../redux/store/configureStore";
import { useGlobalModalContext } from "contexts/GlobalModalContext";
import { useGlobalLoaderContext } from "contexts/GlobalLoaderContext";
import { VER } from "constants/server/api";
import { LOGO_URL, SERVER_NAME } from "constants/server/config";
import { env } from "env";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import { data } from "jquery";
export function ForgetpassSendMail() {
    var navigate = useNavigate();
    var dispatch = useAppDispatch();
    var _useGlobalModalContext = useGlobalModalContext(), modalObj = _useGlobalModalContext.modalObj, setModalObj = _useGlobalModalContext.setModalObj;
    var _useGlobalLoaderContext = useGlobalLoaderContext(), isloading = _useGlobalLoaderContext.isloading, setIsLoading = _useGlobalLoaderContext.setIsLoading;
    var forgetpassSendmailReducer = useAppSelector(function(state) {
        return state.forgetpassSendmailReducer;
    });
    var _useState = _sliced_to_array(useState(function() {
        return localStorage.getItem("forgetpassEmail") || "";
    }), 2), email = _useState[0], setEmail = _useState[1];
    var _useState1 = _sliced_to_array(useState(function() {
        return localStorage.getItem("forgetpassToken") || "";
    }), 2), token = _useState1[0], setToken = _useState1[1];
    var _useState2 = _sliced_to_array(useState({
        visible: false,
        textsuccess: "",
        direction: ""
    }), 2), modalsuccess = _useState2[0], setModalsuccess = _useState2[1];
    var handleForgetpassSendMail = function() {
        if (!email || email === "" || email === undefined || !token || token === "" | token === undefined) {
            setModalObj(_object_spread_props(_object_spread({}, modalObj), {
                visible: true,
                subTitle: "เกิดข้อผิดพลาด",
                navigateDirection: navigate("/forgetpass"),
                title: "กรุณาทำรายการลืมรหัสใหม่อีกครั้ง"
            }));
            return;
        }
        var data = {
            token: token,
            mailsend: email
        };
        dispatch(forgetpassSendmail(data, {
            modalObj: modalObj,
            setModalObj: setModalObj
        }));
    };
    useEffect(function() {
        setIsLoading(forgetpassSendmailReducer.isFetching);
        if (forgetpassSendmailReducer.data && !forgetpassSendmailReducer.isError) {
            setModalsuccess(function(prev) {
                return _object_spread_props(_object_spread({}, prev), {
                    visible: true,
                    textsuccess: "ส่งอีเมลสำเร็จ กรุณาตรวจสอบอีเมลของคุณ",
                    direction: undefined
                });
            });
            dispatch(clearForgetpassSendmail());
            return;
        }
        if (forgetpassSendmailReducer.data && forgetpassSendmailReducer.isError) {
            setModalObj(_object_spread_props(_object_spread({}, modalObj), {
                visible: true,
                subTitle: "เกิดข้อผิดพลาด",
                navigateDirection: navigate("/forgetpass"),
                title: "กรุณาทำรายการลืมรหัสใหม่อีกครั้ง"
            }));
            dispatch(clearForgetpassSendmail());
            return;
        }
    }, [
        forgetpassSendmailReducer
    ]);
    return /*#__PURE__*/ _jsxs("div", {
        className: "loginpage bg-white",
        children: [
            /*#__PURE__*/ _jsx(Row, {
                className: "g-0",
                children: /*#__PURE__*/ _jsx(Col, {
                    className: "d-flex justify-content-center align-items-center h-100vh",
                    children: /*#__PURE__*/ _jsx(Card, {
                        className: "box-login",
                        style: {
                            maxWidth: "550px"
                        },
                        children: /*#__PURE__*/ _jsxs(Card.Body, {
                            className: "",
                            children: [
                                /*#__PURE__*/ _jsx("div", {
                                    className: "d-flex justify-content-center align-items-center mb-3",
                                    children: /*#__PURE__*/ _jsx("div", {
                                        className: "p-3",
                                        style: {
                                            borderRadius: "100px",
                                            backgroundColor: "#8D010C"
                                        },
                                        children: /*#__PURE__*/ _jsx(MailOutlineIcon, {
                                            sx: {
                                                fontSize: 40,
                                                color: "#FFFFFF"
                                            }
                                        })
                                    })
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "text-center fs-20 fw-500 tc-1",
                                    children: "คำขอตั้งรหัสผ่านใหม่สำเร็จ"
                                }),
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "text-center fs-16 fw-500 tc-6",
                                    children: [
                                        "เราได้ส่งอีเมลยืนยันไปที่ ",
                                        /*#__PURE__*/ _jsx("span", {
                                            className: "tc-5",
                                            children: email
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "text-center fs-16 fw-500 mb-4 tc-6",
                                    children: "เปิดอีเมลและตั้งรหัสผ่านใหม่ของคุณ"
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "text-center fs-16 fw-500 mb-4 tc-6",
                                    children: "(ลิงค์การตั้งรหัสผ่านมีอายุใน 24 ชั่วโมง)"
                                }),
                                /*#__PURE__*/ _jsx(Button, {
                                    type: "button",
                                    className: "btn-login w-100",
                                    onClick: function() {
                                        return handleForgetpassSendMail();
                                    },
                                    children: "ไม่ได้รับอีเมล ? คลิกที่นี่เพื่อส่งอีกครั้ง"
                                })
                            ]
                        })
                    })
                })
            }),
            /*#__PURE__*/ _jsx(ModalSuccessCustom, {
                show: modalsuccess.visible,
                onHide: function() {
                    return setModalsuccess(function(prev) {
                        return _object_spread_props(_object_spread({}, prev), {
                            visible: false
                        });
                    });
                },
                textsuccess: modalsuccess.textsuccess,
                navigate: navigate,
                direction: modalsuccess.direction
            })
        ]
    });
}
